import {
  fontSize,
  maxBreakpoints,
  minBreakpoints,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem, stack } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, text } = theme;

export const wrapper = css`
  margin: ${pxToRem(spacing.xl)} 0 ${pxToRem(spacing.xxxxl)};
  ${mediaQuery(
    {
      max: maxBreakpoints.M,
    },
    css`
      margin-top: ${pxToRem(spacing.md)};
    `,
  )}
`;

export const container = css`
  max-width: 960px;
  padding: 0 ${pxToRem(spacing.md)};
  margin: 0 auto;
  min-height: 300px;
  &[data-no-padding='true'] {
    padding: 0;
  }
  &[data-wide='true'] {
    max-width: 1070px;
  }
`;

export const title = css`
  margin: ${pxToRem(spacing.xxl)} 0 ${pxToRem(spacing.xl)} 0;
  text-align: center;
`;

export const copy = css`
  ${fontSize(text.HEADING.XS)}
  margin: ${stack(spacing.xxxl)};
  text-align: center;

  ${mediaQuery(
    {
      min: minBreakpoints.L,
    },
    css`
      margin: ${stack(52)};
    `,
  )}
`;
